module.exports = __webpack_public_path__ + "img/KH.7ddbaf2c.png";